import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { BREAKPOINTS, MAX_CONTENT_WIDTH } from '@/styles/themes/default';

import { ParagraphContainer, Heading } from './Common';

const GridContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 512px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    flex-direction: row;
    max-width: ${MAX_CONTENT_WIDTH}px;
  }
`;

const ImageContainer = styled.picture`
  max-width: 694px;

  img {
    height: auto;
    object-fit: cover;
    width: 100%;
  }
`;

const MessageContainer = styled(ParagraphContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 40px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-bottom: 0;
    margin-right: 100px;
    max-width: 405px;
  }
`;

const Title = styled(Heading)`
  margin-bottom: 40px;
`;

export const CiteExample = () => {
  const { t } = useTranslation();

  return (
    <GridContainer>
      <MessageContainer>
        <Title>{t('landing.citeExample.title')}</Title>
        <p>{t('landing.citeExample.description')}</p>
        <p>{t('landing.citeExample.enrichLectures')}</p>
      </MessageContainer>
      <ImageContainer>
        <img src="/images/landing/citation.png" alt="citation" />
      </ImageContainer>
    </GridContainer>
  );
};
